import axios from 'axios';
import { createQuery } from 'react-query-kit';

import { relativeUrlResolver } from '@/services/utils';

import type { AssetApiRecord } from './assets.types';

const assetUrl = (primaryKey: string) => relativeUrlResolver(`/api/v2/assets/${encodeURIComponent(primaryKey)}`);

/**
 * The asset with every stored value. Without `layout` the API returns all fields, so the
 * detail page gets the system values the `asset_detail` layout lists plus `publicUrl__`,
 * `tags__` and the validation results; `validate` adds the messages in plain text
 * (`__validations__`) and the attribute states (`__attributeStates__`, D-051).
 */
const useDamAsset = createQuery<AssetApiRecord, { primaryKey: string }, Error>({
    queryKey: ['dam', 'asset'],
    fetcher: async ({ primaryKey }) => (await axios.get(assetUrl(primaryKey), { params: { validate: true } })).data,
});

/** Same-origin download of the original file with its file name. */
const damAssetDownloadUrl = (primaryKey: string) => `${assetUrl(primaryKey)}/download`;

export { damAssetDownloadUrl, useDamAsset };
